export default __webpack_public_path__ + "static/media/fridge1-before2-768w.dd847ad1.avif";